module.exports = __webpack_public_path__ + "static/assets/d59f2ae8ced8b6f7a7e0e3dc5917408d.gif";